import { render, staticRenderFns } from "./centerLeft1.vue?vue&type=template&id=1c8b6ebe&scoped=true&"
import script from "./centerLeft1.vue?vue&type=script&lang=js&"
export * from "./centerLeft1.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft1.vue?vue&type=style&index=0&id=1c8b6ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b6ebe",
  null
  
)

export default component.exports